// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__xbcFn","button":"Toast_button__3SFZ0"};